import React from 'react';
import { useVideoConfig, spring, AbsoluteFill, Img, staticFile, interpolate, useCurrentFrame, Easing  } from "remotion";
import '../../App.css';
import { loadFont } from "@remotion/google-fonts/Handlee";


export const Background = ({  BGcolor, GraphicDuration }) => {

  
    const frame = useCurrentFrame();
    const { fps } = useVideoConfig();
    const GraphicDurationNum = parseInt(GraphicDuration);
    const { height } = useVideoConfig();


    const transitionIn = spring({
      fps,
      frame,
      from: 0,
      to: 1,
      config: {
        damping: 400,
      },
      durationInFrames: 13,
    });


    const transitionOutTop = interpolate(
      frame, 
      [(GraphicDurationNum-10), GraphicDurationNum],
      [0, -height/2],
      {
        easing: Easing.bezier(0.8, 0.22, 0.96, 0.65),
        extrapolateRight: "clamp",
        extrapolateLeft: "clamp",
      });

      const transitionOutBottom = interpolate(
        frame, 
        [(GraphicDurationNum-10), GraphicDurationNum],
        [0, height/2],
        {
          easing: Easing.bezier(0.8, 0.22, 0.96, 0.65),
          extrapolateRight: "clamp",
          extrapolateLeft: "clamp",
        });




  return (
    <AbsoluteFill
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'bottom',
          alignItems: 'center',
        }}
        >
              <div
              style={{
                height: '50%',
                backgroundColor: BGcolor,
                width: '100%',
                color: 'white',
                transform: `scaleY(${transitionIn}) translateY(${transitionOutTop}px)`,
                transformOrigin: 'bottom',
              }}>
              </div>
              <div
              style={{
                height: '50%',
                backgroundColor: BGcolor,
                width: '100%',
                color: 'white',
                transform: `scaleY(${transitionIn}) translateY(${transitionOutBottom}px)`,
                transformOrigin: 'top',
                
              }}>
              </div>
        </AbsoluteFill>
  );
};


